// src/App.js
import React, {useEffect, useState} from 'react';
import {Layout} from 'antd';
import {Routes, Route} from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Collections from './pages/collections/Collections';
import AddCollection from './pages/collections/AddCollection';
import EditCollection from './pages/collections/EditCollection';
import Questions from './pages/question/Questions';
import AddQuestion from './pages/question/AddQuestion';
import EditQuestion from './pages/question/EditQuestion';
import CollectionTest from './pages/CollectionTest';
import AuthModal from "./components/AuthModal";
import axios from "axios";
import {API_BASE_URL} from "./config";
import Users from "./pages/Users";
import SatCollections from "./pages/sat_collections/SatCollections";
import AddSatCollection from "./pages/sat_collections/AddSatCollection";
import SatQuestions from "./pages/sat_question/SatQuestions";
import AddSatQuestion from "./pages/sat_question/AddSatQuestion";
import SatCollectionTest from "./pages/SatCollectionTest";
import EditSatQuestion from "./pages/sat_question/EditSatQuestion";
import EditSatCollection from "./pages/sat_collections/EditSatCollection";
import SatCollectionResult from "./pages/SatCollectionResult";

const {Header, Content, Footer, Sider} = Layout;

const AdminLayout = () => (
    <Layout style={{minHeight: '100vh'}}>
        <Sider theme="light">
            <Sidebar/>
        </Sider>
        <Layout>
            <Header style={{background: '#fff', padding: '16px'}}/>
            <Content style={{margin: '24px', padding: '24px', background: '#fff', borderRadius: '8px'}}>
                <Routes>
                    <Route path="/dashboard" element={<Dashboard/>}/>
                    <Route path="/collections" element={<Collections/>}/>
                    <Route path="/users" element={<Users/>}/>
                    <Route path="/collections/add" element={<AddCollection/>}/>
                    <Route path="/collections/edit/:id" element={<EditCollection/>}/>
                    <Route path="/collection/:collection_id/questions" element={<Questions/>}/>
                    <Route path="/collection/:collection_id/question/add" element={<AddQuestion/>}/>
                    <Route path="/collection/:collection_id/question/edit/:question_id/:number" element={<EditQuestion/>}/>
                    <Route path="/sat-collections" element={<SatCollections/>}/>
                    <Route path="/sat-collections/add" element={<AddSatCollection/>}/>
                    <Route path="/sat-collections/edit/:collection_id" element={<EditSatCollection/>}/>
                    <Route path="/sat-collection/:collection_id/questions" element={<SatQuestions/>}/>
                    <Route path="/sat-collection/:collection_id/:step/question/add" element={<AddSatQuestion/>}/>
                    <Route path="/sat-collection/:collection_id/question/edit/:question_id/:step/:number" element={<EditSatQuestion/>}/>
                </Routes>
            </Content>
            <Footer style={{textAlign: 'center', padding: '12px'}}>
                Ant Design ©2025 Created by Ant UED
            </Footer>
        </Layout>
    </Layout>
);

const PageContent = ({user}) => {
    console.log(user)
    return (
        <Routes>
            <Route path="/sat-collection_test/:id" element={<SatCollectionTest/>}/>
            <Route path="/collection_test/:id" element={<CollectionTest/>}/>
            <Route path="/sat-collection-result/:id" element={<SatCollectionResult/>}/>
            {user?.isAdmin ? <Route path="*" element={<AdminLayout/>}/>: null}
        </Routes>
    )
}


const App = () => {
    const [user, setUser] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [content, setContent] = useState(null)

    useEffect(() => {
        const fetchUser = async () => {
            let savedToken = localStorage.getItem('token');

            if (!savedToken) {
                const location = window.location;
                const params = new URLSearchParams(location.search);
                const urlToken = params.get("token");

                if (urlToken) {
                    savedToken = urlToken;
                    localStorage.setItem("token", urlToken);
                    params.delete("token");
                    const newUrl = location.pathname + (params.toString() ? `?${params.toString()}` : '');
                    window.history.replaceState({}, '', newUrl);
                }
            }

            if (!savedToken) {
                setShowModal(true);
                return;
            }

            try {
                const {data} = await axios.get(`${API_BASE_URL}/Me`, {
                    headers: {
                        Authorization: `Bearer ${savedToken}`,
                    },
                });

                setUser(data);
                setContent(<PageContent user={data}/>)
            } catch (error) {
                console.error("Xato:", error);
                localStorage.removeItem("token");
                setShowModal(true);
            }
        };

        fetchUser();
    }, []);
    useEffect(() => {
        localStorage.setItem("user", JSON.stringify(user));
    }, [user]);

    return (
        <>
            {content}

            <AuthModal visible={showModal}/>
        </>
    );
};

export default App;